import "../../stylesheets/App.css";
import "../../stylesheets/Groups.css";
import React, { useState, useEffect } from "react";
import Game from "./Game";
import GameAdmin from "./GameAdmin";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

function Groups(props) {
  const [groups, setGroups] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const apiCall = (url, callback) => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => callback(data))
      .catch((error) => console.log(error));
  };

  const updateGroups = (data) => {
    setGroups(data.data || []);
  };

  useEffect(() => {
    const url = props.admin
      ? process.env.REACT_APP_API_BASE_URL + "/groups/listAdmin"
      : process.env.REACT_APP_API_BASE_URL + "/groups/list";

    apiCall(url, updateGroups);
    setRefresh(false);
  }, [refresh, props.admin]);

  const openGames = (i) => {
    const listEl = document.getElementById("list-" + i);
    const iconEl = document.getElementById("icon-" + i);

    if (listEl) listEl.classList.toggle("active");
    if (iconEl) iconEl.classList.toggle("active");
  };

  return (
    <>
      {groups.map((item, i) => {
        if (item.name != 0) {
          return (
            <div key={"div" + i}>
              <div
                className={`group-title-container g${i}`}
                key={"group" + i}
                onClick={() => openGames(i)}
              >
                <div className="group-title" key={"group-title" + i}>
                  {"Grupo " + item.name}
                </div>
                <div className="group-icon" id={"icon-" + i} key={"group-icon" + i}>
                  <FontAwesomeIcon icon={solid("chevron-down")} />
                </div>
              </div>

              <ul className="teams-by-group-list" id={"list-" + i}>
                {props.admin
                  ? item.games.map((game) => (
                      <li key={"li_" + game.idGame}>
                        <GameAdmin
                          key={game.idGame}
                          data={game}
                          teamList={props.teamList}
                          setRefresh={setRefresh}
                        />
                      </li>
                    ))
                  : item.games.map((game) => (
                      <li key={"li_" + game.idGame}>
                        <Game
                          key={"game_" + game.idGame}
                          data={game}
                          bet={props.bets?.find(
                            (bet) => bet.game.idGame == game.idGame
                          )}
                          setRefresh={setRefresh}
                        />
                      </li>
                    ))}
              </ul>
            </div>
          );
        }
        return null;
      })}
    </>
  );
}

export default Groups;
